// extracted by mini-css-extract-plugin
export default {"countryHolder":"styles_countryHolder__k23EB","icon":"styles_icon__2UNMq"};